import React, { useState, useEffect } from 'react';
import { Loading } from 'carbon-components-react';
import styled from 'styled-components';

// Components
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import CommercialProductsContent from './CommercialProductsContent';
import TileHeader from '../../components/TileHeader/TileHeader';
import NewCommercialProductModal from './NewCommercialProductModal';
import DeleteCommercialProductModal from './DeleteCommercialProductModal';
// api
// import { getAllCommercialProducts } from '../../api/commercialProducts';

import { getCommercialProducts } from '../../api/commercialProducts';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import usePollReport from '../../hooks/usePollReport';
import { triggerReport } from '../../api/studyListApi';
import { toaster } from '../../helpers/toaster';

const CommercialProducts = ({
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(true);

  const [commercialProductsList, setCommercialProductsList] = useState(null);
  const [openNewCommercialProductModal, setOpenNewCommercialProductModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [openCommercialProductModal, setOpenCommercialProductModal] = useState(false);
  const [detailModalMode, setDetailModalMode] = useState("create");
  const [commercialProduct, setCommercialProduct] = useState(null);

  const { startPolling, status: reportStatus } = usePollReport({
    onSuccess: () => { toaster('Commercial products report downloaded successfully', 'success'); },
    onError: () => toaster('Failed to generate report. Please try again.', 'error'),
  });

  const [openReportModal, setOpenReportModal] = useState(false);

  const handleGenerateReport = () => {
    setOpenReportModal(false);
    triggerReport('commercialProducts')
      .then(({ task_id }) => {
        toaster('Generating commercial products report...', 'info');
        startPolling(task_id);
      })
      .catch(() => toaster('Failed to start report generation.', 'error'));
  };

  const refreshCommercialProductsList = async () => {
    
    setLoading(true);
    let data = await getCommercialProducts();
    setCommercialProductsList(data); 
    if(data){
      setLoading(false);
    }
  }
  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true);
    setDeleteItem(itemId);
  };

  const closeModal = () => {
    setOpenCommercialProductModal(false);
    setCommercialProduct(null);
  };
  
  const addNewCommercialProduct = () => {
    openCommercialProductModal(true);
  };

  useEffect(() => {
    refreshCommercialProductsList();
  }, []);

  return (
    <Container>
      <ContentContainer>
        <TileHeader 
            title="Commercial Products"
            subtitle="A list of all commercial products."
            size="lg"
        />

        
				

        <CommercialProductsContent
          commercialProductsList={commercialProductsList}
          setOpenNewCommercialProductModal={setOpenCommercialProductModal}
          onDeleteClicked={showDeleteConfirm}
          setDetailModalMode={setDetailModalMode}
          setCommercialProduct={setCommercialProduct}
          setMode={setDetailModalMode}
          onGenerateReport={() => setOpenReportModal(true)}
          reportStatus={reportStatus}
          />

        <NewCommercialProductModal
          open={openCommercialProductModal}
          commercialProductData={commercialProduct}
          refreshList={refreshCommercialProductsList}
          onClose={closeModal}
          mode={detailModalMode}
        />
        <ConfirmModal
          title="Generate Report"
          content="Do you want to generate the report? This may take awhile. Navigating away from this page will stop the report generation."
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          onConfirm={handleGenerateReport}
        />
        <DeleteCommercialProductModal
          open={openDeleteModal}
          refreshList={refreshCommercialProductsList}
          onClose={() => setOpenDeleteModal(false)}
          commercialProductList={commercialProductsList}
          deleteItem={deleteItem}
        />
        
      </ContentContainer>
    </Container>
  );
};

export default CommercialProducts;